import { FunctionComponent, ReactElement } from "react";
import { ADDON_MODAL_CONSTANTS } from "rivals/components/shared/AddonOptions/constants";
import Button from "rivals/components/shared/Button";
import { HOST_BASE_PATH, PROTOCOL } from "rivals/services/base";
import styles from "./SubscriptionCardUpsells.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const { SPY } = ADDON_MODAL_CONSTANTS;

const {
  annualUpgradeText,
  annualUpgradeTitle,
  addOnTitle,
  addOnDescription
} = strings;

const SubscriptionCardUpsells: FunctionComponent<OwnProps> = ({
  addOn,
  annualUpgrade = false,
  buttonText = "Add",
  site,
  buyAddOnModalTrigger,
  subscriptionId
}): ReactElement => {
  let upsellTitle;
  let upsellText;
  let upsellButton;
  let upsellLabel;

  const goldMemberLabel = <div className={styles.goldMemberLabel} />;

  const addOnSiteLogo = addOn && (
    <div
      className={styles.siteLabel}
      style={{ backgroundColor: addOn.siteColor }}
    >
      <img
        alt="site logo"
        className={styles.siteLogo}
        src={addOn.siteLogoUrl || ""}
      />
    </div>
  );

  if (annualUpgrade) {
    upsellTitle = annualUpgradeTitle;
    upsellText = annualUpgradeText;
    upsellLabel = goldMemberLabel;
    upsellButton = (
      <Button
        buttonText={buttonText}
        className={styles.upgradeButton}
        inverted
        url={`${PROTOCOL}${site.shortName.toLowerCase()}.${HOST_BASE_PATH}/users/subscriptions/${subscriptionId}/upgrade`}
      />
    );
  } else if (addOn) {
    upsellTitle = addOnTitle[`${addOn.type} ${addOn.type}`];
    upsellText = addOnDescription[`${addOn.type} ${addOn.type}`];
    upsellLabel = addOnSiteLogo;
    upsellButton = buyAddOnModalTrigger && (
      <Button
        buttonText={buttonText}
        className={styles.upgradeButton}
        inverted
        onClick={(): void => {
          buyAddOnModalTrigger(addOn);
        }}
      />
    );
  }

  const style = addOn && addOn.type === SPY ? "AddOn" : "Annual";

  const upsell = (
    <div className={styles[`upsellBanner${style}`]}>
      <div className={styles.upsellHeader}>
        <div className={styles.headerTitle}>{upsellTitle}</div>
        {upsellLabel}
      </div>
      <div className={styles.upsellBody}>
        <div className={styles.upsellText}>
          {addOn && (
            <div className={styles.text}>{addOn.formattedPriceString}</div>
          )}
          <div className={styles.text}>{upsellText}</div>
        </div>
        <div className={styles.button}>{upsellButton}</div>
      </div>
    </div>
  );

  return <div className={styles.subscriptionCardUpsell}>{upsell}</div>;
};

export default SubscriptionCardUpsells;
